<div class="checkout-overlay" (click)="handleOffcanvasClose()">
	<div class="checkout-popup" (click)="$event.stopPropagation()">
		<div class="popup-header">
			<div class="header-text">
				<span class="header-eyebrow"><i class="fa-solid fa-clipboard-check"></i> Almost there</span>
				<h1>Fill mandatory details</h1>
				<p class="header-sub">We'll use these to file your application securely.</p>
			</div>
			<button type="button" (click)="handleOffcanvasClose()" class="popup-close"
				data-bs-dismiss="offcanvas" aria-label="Close">
				<i class="fa-solid fa-xmark"></i>
			</button>
		</div>
		<div class="popup-body">
			<section>
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 " *ngIf="formDetails">
						<form [formGroup]="pujaOrderForm" (ngSubmit)="onSubmit()">
							<div class="card ">
								<div class="row justify-content-center">
									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.name">
										<label for="name" class="form-label">Enter full name<span
												class="text-danger">*</span></label>
										<input type="text" class="form-control" id="customerName"
											formControlName="customerName" placeholder="Enter name" [class.is-invalid]="pujaOrderForm.get('customerName')?.touched && pujaOrderForm.get('customerName')?.invalid">
										<div class="field-error" *ngIf="pujaOrderForm.get('customerName')?.touched && pujaOrderForm.get('customerName')?.invalid">
												<span *ngIf="pujaOrderForm.get('customerName')?.errors?.['required']">Full name is required</span>
												<span *ngIf="pujaOrderForm.get('customerName')?.errors?.['minlength']">Enter at least 2 characters</span>
											</div>
									</div>


									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.email">
										<label for="name" class="form-label">Enter Email<span
												class="text-danger">*</span></label>
										<input type="text" class="form-control" id="customerEmail"
											formControlName="customerEmail" placeholder="Enter Email" [class.is-invalid]="pujaOrderForm.get('customerEmail')?.touched && pujaOrderForm.get('customerEmail')?.invalid">
										<div class="field-error" *ngIf="pujaOrderForm.get('customerEmail')?.touched && pujaOrderForm.get('customerEmail')?.invalid">
												<span *ngIf="pujaOrderForm.get('customerEmail')?.errors?.['required']">Email is required</span>
												<span *ngIf="pujaOrderForm.get('customerEmail')?.errors?.['email']">Enter a valid email address</span>
											</div>
									</div>





									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.address">
										<label for="name" class="form-label">Address<span
												class="text-danger">*</span></label>
										<input type="text" class="form-control" id="address" formControlName="address"
											placeholder="Address" [class.is-invalid]="pujaOrderForm.get('address')?.touched && pujaOrderForm.get('address')?.invalid">
										<div class="field-error" *ngIf="pujaOrderForm.get('address')?.touched && pujaOrderForm.get('address')?.invalid">
												<span *ngIf="pujaOrderForm.get('address')?.errors?.['required']">Address is required</span>
												<span *ngIf="pujaOrderForm.get('address')?.errors?.['minlength']">Enter a complete address</span>
											</div>
									</div>


									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.assessmentYear">
										<label for="birtDate" class="form-label">Assessment Year <span
												class="text-danger">*</span></label>
										<select name="gender" formControlName="assessmentYear" class="form-control" [class.is-invalid]="pujaOrderForm.get('assessmentYear')?.touched && pujaOrderForm.get('assessmentYear')?.invalid"
											id="">
											<option value="">Select Assessment Year</option>
											<option value="2020-2021">2020-2021</option>
											<option value="2021-2022">2021-2022</option>
											<option value="2022-2023">2022-2023</option>
											<option value="2023-2024">2023-2024</option>
											<option value="2024-2025">2024-2025</option>
											<option value="2025-2026">2025-2026</option>
											<option value="2026-2027">2026-2027</option>
										</select>
										<div class="field-error" *ngIf="pujaOrderForm.get('assessmentYear')?.touched && pujaOrderForm.get('assessmentYear')?.invalid">
											<span>Please select assessment year</span>
										</div>

									</div>




									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.panCardNumber">
										<label for="birtDate" class="form-label">Pan Card Number<span
												class="text-danger">*</span></label>
										<input type="text" class="form-control" id="panCardNumber"
											formControlName="panCardNumber" placeholder="Enter Pan number" [class.is-invalid]="pujaOrderForm.get('panCardNumber')?.touched && pujaOrderForm.get('panCardNumber')?.invalid"
											autocomplete="off">
										<div class="field-error" *ngIf="pujaOrderForm.get('panCardNumber')?.touched && pujaOrderForm.get('panCardNumber')?.invalid">
											<span *ngIf="pujaOrderForm.get('panCardNumber')?.errors?.['required']">PAN number is required</span>
											<span *ngIf="pujaOrderForm.get('panCardNumber')?.errors?.['pattern']">Enter a valid PAN (e.g. ABCDE1234F)</span>
										</div>
									</div>


									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.incomeTaxId">
										<div class="label-row">
											<label for="incomeTaxId" class="form-label">Enter Income tax portal Id<span class="text-danger">*</span></label>
											<button type="button" class="same-as-pan" *ngIf="formDetails?.panCardNumber"
												(click)="useSameAsPan()" [disabled]="!pujaOrderForm.get('panCardNumber')?.value"
												title="Copy your PAN number into this field">
												<i class="fa-regular fa-copy"></i> Same as PAN
											</button>
										</div>
										<input type="text" class="form-control" id="incomeTaxId"
											formControlName="incomeTaxId" placeholder="Enter Income tax portal Id." [class.is-invalid]="pujaOrderForm.get('incomeTaxId')?.touched && pujaOrderForm.get('incomeTaxId')?.invalid"
											autocomplete="off">
										<div class="field-hint"><i class="fa-solid fa-circle-info"></i> Usually the same as your PAN number — tap <strong>Same as PAN</strong> to autofill.</div>
										<div class="field-error" *ngIf="pujaOrderForm.get('incomeTaxId')?.touched && pujaOrderForm.get('incomeTaxId')?.invalid">
											<span>Income tax portal Id is required</span>
										</div>
									</div>

									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.dob">
										<label for="birtDate" class="form-label">Date of Birth <span
												class="text-danger">*</span></label>
										<input type="text" class="form-control" id="birtDate" formControlName="birtDate"
											placeholder="Date of Birth (DD/MM/YYYY)" bsDatepicker autocomplete="off" [class.is-invalid]="pujaOrderForm.get('birtDate')?.touched && pujaOrderForm.get('birtDate')?.invalid">
										<div class="field-error" *ngIf="pujaOrderForm.get('birtDate')?.touched && pujaOrderForm.get('birtDate')?.invalid">
											<span>Date of birth is required</span>
										</div>
									</div>
									<div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="formDetails?.timeofbirth">
										<label for="birthTime" class="form-label">Time of Birth <span
												class="text-danger">*</span></label>
										<timepicker id="birthTime" formControlName="birthTime"></timepicker>
										<!-- <input type="text" class="form-control" id="birthTime" formControlName="birthTime"
										placeholder="Time of Birth  (HH:MM AM/PM)" > -->
										<div class="field-error" *ngIf="pujaOrderForm.get('birthTime')?.touched && pujaOrderForm.get('birthTime')?.invalid">
												<span>Time of birth is required</span>
											</div>
									</div>
									<div class="col-lg-12 col-md-6 col-sm-6 mb-3" *ngIf="formDetails?.placeOfBirth">
										<label for="birthPlace" class="form-label">Birth Place<span
												class="text-danger">*</span></label>
										<input type="text" class="form-control" id="birthPlace"
											formControlName="birthPlace" placeholder="Entet Birth Place" [class.is-invalid]="pujaOrderForm.get('birthPlace')?.touched && pujaOrderForm.get('birthPlace')?.invalid">
										<div class="field-error" *ngIf="pujaOrderForm.get('birthPlace')?.touched && pujaOrderForm.get('birthPlace')?.invalid">
												<span>Birth place is required</span>
											</div>
									</div>

									<div class="col-lg-12 col-md-6 col-sm-6 mb-2" *ngIf="formDetails?.comment">
										<label for="comments" class="form-label">Comment(if any)
										</label>
										<!-- <input type="text" class="form-control" id="comments" formControlName="comments"
											placeholder="Enter comments"> -->
										<textarea class="form-control" id="comments" formControlName="comments" rows="4"
											placeholder="Enter your comments">
										 </textarea>
										<div id="comments" class="form-text"> </div>
									</div>

									<div class="row btn-popup-submit__btn">
										<div class="col-lg-12 col-md-12 col-sm-12 ">
											<button type="submit" class="btn strtchat">
												<span>Submit &amp; Continue</span>
												<i class="fa-solid fa-arrow-right"></i>
											</button>
											<p class="secure-note">
												<i class="fa-solid fa-lock"></i>
												Your information is encrypted &amp; 100% secure
											</p>
										</div>
									</div>
								</div>

							</div>

						</form>


					</div>
				</div>

			</section>
		</div>
	</div>
</div>